import { Formik } from "formik";
import Loader from "../components/Loader";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import SubHeader from "../components/SubHeader";
import { pageRoutes } from "../routes/PageRoutes";
import { AddSupplierSchema } from "../auth/Schema";
import React, { useEffect, useState } from "react";
import ErrorMessage from "../components/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { addSupplierDetails } from "../redux/actions/staffActions";
import GuidedTour from "../components/GuidedTour";
import { setTourStep } from "../redux/reducers/tourReducer";

const AddSupplier = () => {
  const { isLoading1 } = useSelector((state) => state?.staffReducer);
  const initialState = {
    email: "",
    name: "",
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isToggle, setIsToggle] = useState(false);

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  const onHandleAddSupplier = async (values, { setSubmitting }) => {
    setSubmitting(false);
    const callback = (response) => {
      if (response.success) {
        navigate(pageRoutes?.all_supplier);
      }
    };
    const data = {
      email: values?.email?.trim(),
      name: values?.name?.trim(),
    };
    dispatch(addSupplierDetails({ payload: data, callback }));
  };

  const [runTour, setRunTour] = useState(false);
  const tooltipSeen = useSelector((state) => state?.authReducer?.tooltipSeen);
  const { active: isTourActive, step: tourStep } = useSelector(
    (state) => state?.tourReducer,
  );

  const steps = React.useMemo(
    () => [
      {
        target: ".add_supplier_final_btn",
        spotlightTarget: ".add_supplier_block",
        scrollTarget: ".add_supplier_block",
        title: "Enter Supplier details",
        content:
          "Provide the Supplier information to assign tasks and manage services.",
        placement: "bottom",
        nextLabel: "Next",
        skipLabel: "Skip",
        showSkipButton: true,
      },
    ],
    [],
  );

  useEffect(() => {
    if (tooltipSeen === true) {
      setRunTour(false);
      return undefined;
    }

    if (!isTourActive || tourStep !== 12) {
      setRunTour(false);
      return undefined;
    }

    const interval = setInterval(() => {
      const el = document.querySelector(".add_supplier_final_btn");

      if (el) {
        setRunTour(true);
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [isTourActive, tooltipSeen, tourStep]);

  if (isLoading1) {
    return <Loader />;
  }
  return (
    <div className="ct_dashbaord_bg">
      <GuidedTour
        steps={tooltipSeen === true || !isTourActive || tourStep !== 12 ? [] : steps}
        run={runTour && tooltipSeen !== true && isTourActive && tourStep === 12}
        markSeenApi={false}
        onSkip={() => {
          setRunTour(false);
        }}
        onComplete={() => {
          setRunTour(false);
          dispatch(setTourStep(13));
          navigate(pageRoutes.dashboard);
        }}
      />
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar path="" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />

          <div class="ct_px_23 ct_mt_30 pb-5">
            <div class="">
              <div className="ct_mb_30">
                <SubHeader />
              </div>

              <Formik
                initialValues={initialState}
                validationSchema={AddSupplierSchema}
                onSubmit={(values, actions) => {
                  onHandleAddSupplier(values, actions);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  resetForm,
                }) => (
                  <form>
                    <div className="add_supplier_block">
                    <div className="ct_white_bg_1 pb-5 add_supplier_submit_btn">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              Supplier Name{" "}
                              <span className="ct_required_star">*</span>
                            </label>
                            <input
                              id="name"
                              placeholder="Enter supplier name"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.name}
                              type="text"
                              className="form-control ct_input ct_transparent_input"
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="name"
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-12">
                                                                  <div className="form-group mb-3">
                                                                      <label className="mb-1"><strong>Company Description</strong> <span
                                                                          className="ct_required_star">*</span></label>
                                                                      <textarea
                                                                          id="company_description"
                                                                          onBlur={handleBlur}
                                                                          onChange={handleChange}
                                                                          value={values?.company_description}
                                                                          className="form-control"
                                                                      />
                                                                      <ErrorMessage
                                                                          errors={errors}
                                                                          touched={touched}
                                                                          fieldName="company_description"
                                                                      />
                                                                  </div>
                                                              </div> */}
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              Email Address{" "}
                              <span className="ct_required_star">*</span>
                            </label>
                            <input
                              id="email"
                              placeholder="Enter email address"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.email}
                              type="email"
                              className="form-control ct_input ct_transparent_input"
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="email"
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-12">
                                                                  <div className="form-group mb-3">
                                                                      <label className="mb-1"><strong>Contact No. </strong> <span
                                                                          className="ct_required_star">*</span></label>
                                                                      <input
                                                                          id="phone_no"
                                                                          onBlur={handleBlur}
                                                                          onChange={handleChange}
                                                                          value={values?.phone_no}
                                                                          type="text"
                                                                          className="form-control"
                                                                      />
                                                                      <ErrorMessage
                                                                          errors={errors}
                                                                          touched={touched}
                                                                          fieldName="phone_no"
                                                                      />
                                                                  </div>
                                                              </div> */}
                        {/* <div className="col-md-12">
                                                                  <div className="form-group mb-3">
                                                                      <label className="mb-1"><strong>City</strong> <span className="ct_required_star">*</span></label>
                                                                      <input
                                                                          id="city"
                                                                          onBlur={handleBlur}
                                                                          onChange={handleChange}
                                                                          value={values?.city}
                                                                          type="text"
                                                                          className="form-control"
                                                                      />
                                                                      <ErrorMessage
                                                                          errors={errors}
                                                                          touched={touched}
                                                                          fieldName="city"
                                                                      />
                                                                  </div>
                                                              </div> */}
                      </div>
                         </div>
                      <div class="d-flex justify-content-end gap-3 ct_mt_40">
                        <button
                          type="button"
                          onClick={() => resetForm()}
                          class="ct_border_radius_5 ct_h_40 ct_orange_transparent_btn"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          onClick={handleSubmit}
                          class="ct_border_radius_5 ct_h_40 ct_orange_btn add_supplier_final_btn"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                 
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSupplier;
